import Breadcrumbs from "@/components/common/sections/Breadcrumbs";
import BreadcrumbsImage from "@/assets/images/breadcrumbs/cloud-solution-breadcrumbs.webp";

export default function AISolutionsPage() {
	return (
		<>
			<Breadcrumbs
				title="Empower Your Business with Cutting-Edge Cloud Solutions"
				breadcrumbText="Cloud solutions"
				backgroundImage={BreadcrumbsImage}
			/>
		</>
	);
}